/**
 * @generated SignedSource<<8129b31f49af4c5253919d9389d8eb08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSettings_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileSettingsForm_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

node.hash = "3040f53bb267dd3fac174f915a0aef81";

module.exports = node;
